import React from "react";

export const Spinner = ({ name = 'loader01', color }: { name?: string, color?: string }) => {
    return (
        <div className="bg-black/50 flex items-center justify-center fixed top-0 left-0 w-full h-full">
            <div className="lds-spinner"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>
        </div>
    )

}